import { render, staticRenderFns } from "./GiftConfig.vue?vue&type=template&id=a1650484&scoped=true&"
import script from "./GiftConfig.vue?vue&type=script&lang=js&"
export * from "./GiftConfig.vue?vue&type=script&lang=js&"
import style0 from "./GiftConfig.vue?vue&type=style&index=0&id=a1650484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1650484",
  null
  
)

export default component.exports